/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Shadow_Size_LabelInputs */

const en_styles_shadow_size_label = /** @type {(inputs: Styles_Shadow_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shadow Size`)
};

const fr_styles_shadow_size_label = /** @type {(inputs: Styles_Shadow_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille d'ombre`)
};

const de_styles_shadow_size_label = /** @type {(inputs: Styles_Shadow_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schattengröße`)
};

const it_styles_shadow_size_label = /** @type {(inputs: Styles_Shadow_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensione dell'ombra`)
};

const ru_styles_shadow_size_label = /** @type {(inputs: Styles_Shadow_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Размер тени`)
};

const es_styles_shadow_size_label = /** @type {(inputs: Styles_Shadow_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño de la sombra`)
};

const zh_cn2_styles_shadow_size_label = /** @type {(inputs: Styles_Shadow_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阴影大小`)
};

const ja_styles_shadow_size_label = /** @type {(inputs: Styles_Shadow_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`影のサイズ`)
};

const hi_styles_shadow_size_label = /** @type {(inputs: Styles_Shadow_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`छाया का आकार`)
};

const pt_pt2_styles_shadow_size_label = /** @type {(inputs: Styles_Shadow_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho da sombra`)
};

/**
* | output |
* | --- |
* | "Shadow Size" |
*
* @param {Styles_Shadow_Size_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_shadow_size_label = /** @type {((inputs?: Styles_Shadow_Size_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Shadow_Size_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_shadow_size_label(inputs)
	if (locale === "de") return de_styles_shadow_size_label(inputs)
	if (locale === "it") return it_styles_shadow_size_label(inputs)
	if (locale === "ru") return ru_styles_shadow_size_label(inputs)
	if (locale === "es") return es_styles_shadow_size_label(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_shadow_size_label(inputs)
	if (locale === "ja") return ja_styles_shadow_size_label(inputs)
	if (locale === "hi") return hi_styles_shadow_size_label(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_shadow_size_label(inputs)
	return en_styles_shadow_size_label(inputs)
});